import React from 'react';
import DocumentLoader, {MIME} from '../../controllers/DocumentLoader';
// import { rootAPI } from '../../constants/globals';
import Spinner from '../Spinner/Spinner';
import Error, {ErrorLevel} from '../Error/Error';
import {Registrar} from '../../model/Registrar';
import Flex from '../StyledComponents/Flex';
import {useTranslation} from "@nic-react-i18n/core";
import {useQuery} from "@tanstack/react-query";
import {setUrlToHTTPs} from "../../utils";
import {AppConf} from "../../AppConf";
import {useKeycloak} from "@nic-react/auth";
import {useAppendAuthorizationHeader} from "../../utils/connector/api-connector";
import Markdown from "react-markdown";

interface RegistrarInfoI {
    registrar: string;
    enabled: boolean;
}
type RegistrarInfoProps = RegistrarInfoI;
const RegistrarInfo: React.FC<RegistrarInfoProps> = (props) =>  {
    const {registrar} = props
    const {locale, t} = useTranslation()
    const {keycloak} = useKeycloak()
    const registrarApi = AppConf.getRegistrarRoot(keycloak.realm);

    const header = useAppendAuthorizationHeader()

    const registrarData = useQuery({
        queryKey: ["registrar", keycloak.registrar],
        queryFn: async () => {
            const data =
                await fetch(setUrlToHTTPs(`${registrarApi}`), {...header})

            return data.json()
        }
    })


    const renderDocument = (head: string, tail: string, registrar: string, registrarDTO: Registrar) => {
        return (
            <div>
                <DocumentLoader
                    mime={MIME.text}
                    documentBase={head}
                    baseURL={'templates'}
                />
                <div style={{marginBottom: '1rem'}}>
                    <Markdown
                        components={{p: 'span'}}
                    >
                        {t('info.registrar', {registrar: registrar, code: registrarDTO.voiceCode})}
                    </Markdown>

                </div>
                <DocumentLoader
                    mime={MIME.text}
                    documentBase={tail}
                    baseURL={'templates'}
                />
            </div>
        );
    }


    let component = <Spinner/>;

    if (registrarData.isFetched) {
        const head = `infoHead.${locale}`;
        const tail = `infoTail.${locale}`;

        const {data} = registrarData;

        let registrarDTO = new Registrar();
        registrarDTO.voiceCode = data.voiceCode;
        registrarDTO.created = data.created;
        registrarDTO.email = data.email;
        registrarDTO.emailLang = data.emailLang;
        registrarDTO.voice = data.voice;
        registrarDTO.lastUpdate = data.lastUpdate;
        registrarDTO.name = data.name;
        registrarDTO.publish = data.publish;
        registrarDTO.status = data.status;
        registrarDTO.statusDate = data.statusDate;
        registrarDTO.webUrl = data.webUrl;
        registrarDTO.links = data._links;
        registrarDTO.webAddress = data.webAddress;

        component = renderDocument(head, tail, registrar, registrarDTO);


    }

    if (registrarData.isError) {
        component = (
            <Error
                level={ErrorLevel.ERROR}
                title={t('error.registrar.title')}
                error={registrarData.error}
            />
        )
    }

        return (
            <Flex
                direction={'row'}
                wrap={'wrap'}
                align={'flex-start'}
                justify={'flex-start'}
            >
                {component}
            </Flex>
        );
}

export default RegistrarInfo
